// extracted by mini-css-extract-plugin
module.exports = {"SmallContainer":"style_SmallContainer__24B5v","CenteredContent":"style_CenteredContent__3QTPC"};